import * as React from 'react';
const SvgUpload = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      fill="#545C62"
      d="M9.47 5.47a.75.75 0 0 1 1.06 0l3 3a.75.75 0 0 1-1.06 1.06l-1.72-1.72V17a.75.75 0 0 1-1.5 0V7.81L7.53 9.53a.75.75 0 0 1-1.06-1.06zM3.5 3.75a.75.75 0 0 1 0-1.5h13a.75.75 0 0 1 0 1.5z"
    />
  </svg>
);
export default SvgUpload;
